import { buildDomainSeoBundle } from "./agenticSeoUtils";

export const PUBLIC_SECTOR_DOMAIN_INTRO = {
  title: "Public Sector & Government",
  content: "Agentic AI workflow automation for Public Sector & Government — across Citizen Grievances, Transparency, and Municipal Services. Use cases span grievance triage and routing, RTI or FOI response drafting support, and municipal case summary assistance. Practical deployments for government agencies in India, UAE, KSA, UK, and USA with human-in-the-loop review, status tracking, and audit evidence.",
  seoDescription: "Public sector government agentic AI — citizen grievances, transparency RTI FOI, municipal services. Grievance triage routing, RTI response drafting, municipal case summary. Case management document management integration.",
};

const slug = (label) => label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

function withMeta(uc) { return { ...uc, groupId: slug(uc.subIndustry), seoTitle: uc.title, title: uc.shortTitle || uc.title }; }

const PUBLIC_SECTOR_SYSTEMS = "Case Management, Document Management, CRM, Email, Portal, Power BI";

const RAW = [
  {
    id: "rti-or-foi-response-drafting-support",
    subIndustry: "Transparency",
    department: "Records",
    businessProcess: "RTI or FOI response drafting support",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "RTI or FOI response drafting support",
    title: "Rti Or Foi Response Drafting Support Automation for Public Sector & Government",
    seoKeywords: "public sector & government, rti or foi response drafting support, AI automation, RPA, agentic AI, document AI",
    challenge: "Officers manually search records and draft responses for information requests.",
    solution: "Implement Agentic AI + Document AI to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    summary: "Transparency teams can improve rti or foi response drafting support with agentic AI workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + Document AI",
    buyerPersona: "Records Head, Legal Head",
    systems: PUBLIC_SECTOR_SYSTEMS,
    agentsRequired: "Document Extraction Agent, RTI Validation Agent, Exception Agent",
    inputData: "Forms, PDFs, emails, scanned documents, attachments, master data and rti or foi response drafting support rules",
    outputActions: "Extracted structured data, validation results, exception list and approval-ready rti or foi response drafting support record",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "Medium",
  },
  {
    id: "municipal-case-summary-assistant",
    subIndustry: "Municipal Services",
    department: "Legal",
    businessProcess: "Municipal case summary assistant",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Municipal case summary assistant",
    title: "Municipal Case Summary Assistant Automation for Public Sector & Government",
    seoKeywords: "public sector & government, municipal case summary assistant, AI automation, RPA, agentic AI, document AI",
    challenge: "Case notes, hearing dates, notices and correspondence are summarized manually.",
    solution: "Implement Agentic AI + Document AI to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    summary: "Municipal Services teams can improve municipal case summary assistant with agentic AI workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Agentic AI + Document AI",
    buyerPersona: "Legal Head, Municipal Commissioner",
    systems: PUBLIC_SECTOR_SYSTEMS,
    agentsRequired: "Document Extraction Agent, Municipal Validation Agent, Exception Agent",
    inputData: "Forms, PDFs, emails, scanned documents, attachments, master data and municipal case summary assistant rules",
    outputActions: "Extracted structured data, validation results, exception list and approval-ready municipal case summary assistant record",
    keyBenefits: "Stronger Controls, Faster Review, Clearer Audit Trail And Fewer Missed Exceptions",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "Medium",
  },
];
export const PUBLIC_SECTOR_USE_CASES = RAW.map(withMeta);
const GROUP_ORDER = ["Transparency", "Municipal Services"];
export const PUBLIC_SECTOR_GROUPS = GROUP_ORDER.map((label) => ({ id: slug(label), label })).filter((g) => PUBLIC_SECTOR_USE_CASES.some((uc) => uc.groupId === g.id));
const seo = buildDomainSeoBundle({ domainSlug: 'public-sector-domain', domainIntro: PUBLIC_SECTOR_DOMAIN_INTRO, useCases: PUBLIC_SECTOR_USE_CASES });
export const PUBLIC_SECTOR_USE_CASES_SEO = seo.useCasesSeo;
export const PUBLIC_SECTOR_DOMAIN_FAQS = seo.domainFaqs;
export const PUBLIC_SECTOR_ITEM_LIST_JSONLD = seo.itemListJsonLd;
export const PUBLIC_SECTOR_FAQ_JSONLD = seo.faqJsonLd;
export const PUBLIC_SECTOR_BREADCRUMB_JSONLD = seo.breadcrumbJsonLd;
export const PUBLIC_SECTOR_WEBPAGE_JSONLD = seo.webPageJsonLd;

